import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckInvalid = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 195.8 207.3",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M114.5 103.6 192 21.3c4.5-4.8 4.3-12.4-.5-16.9-4.8-4.5-12.4-4.3-16.9.5L98.1 86.1 21.7 4.9C17.2.1 9.6-.1 4.8 4.4s-5 12.1-.5 16.9l77.4 82.3-77.4 82.2A11.99 11.99 0 0 0 13 206c3.2 0 6.4-1.3 8.7-3.8L98.1 121l76.4 81.2c2.4 2.5 5.5 3.8 8.7 3.8a11.99 11.99 0 0 0 8.7-20.2l-77.4-82.2z",
		fill: "#fff"
	})
});
export default SvgCheckInvalid;
